var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPdfDigital = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 168,
  viewBox: "0 0 100 168",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B7C4CE",
  fillRule: "nonzero",
  d: "M96 0a4 4 0 0 1 4 4v160a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm0 4H4v160h92zM46 48v108H12V48zm-4 34H16v70h26zm0-30H16v26h26zm4-28v16H12V24zm25 12v4H54v-4zm-29-8H16v8h26zm46-4v4H54v-4zm0-12v4H12v-4z"
})));
export default SvgPdfDigital;